import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import instance from "../axios/global";
import clientlogo from "../assets/astro.jpg";
import ClientMonthlyTotals from "../components/ClientMonthlyTotals";
import ClientSummaryTable, { formatAmount } from "../components/ClientSummaryTable";
import LoaderComp from "../components/LoaderComp";

const ClientBDC = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [summary, setSummary] = useState(null);
  const [view, setView] = useState("tableau");
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;
    setSummary(null);
    setError("");
    instance.get(`/client/${id}/summary`)
      .then(({ data }) => { if (active) setSummary(data); })
      .catch(() => { if (active) setError("Impossible de charger ce client."); });
    return () => { active = false; };
  }, [id]);

  if (error) return <p role="alert">{error}</p>;
  if (!summary) return <LoaderComp />;

  return (
    <div className="clientBDC">
      <div className="container-header-clientbdc">
        <div className="logo-code"><img src={clientlogo} alt="" /></div>
        <div className="div-client-infos">
          <h1>{summary.client.name}</h1>
          <div className="div-total-create-client">
            <div className="descrip-totals">
              <p>Total bons de commande {summary.client.name} :</p>
              <span>{formatAmount(summary.grandTotal)}</span>
            </div>
          </div>
        </div>
      </div>

      <section className="table-bdcbyclient">
        <div className="nav-control">
          <div className="nav-userbdc">
            <button type="button" onClick={() => setView("tableau")}>Client</button>
            <button type="button" onClick={() => setView("global")}>Global</button>
          </div>
        </div>
        {view === "tableau" ? (
          summary.bdcs.length ? (
            <ClientSummaryTable
              months={summary.months}
              rows={summary.bdcs}
              firstColumn="Nom"
              showAccountingCode
              onRowClick={(bdcId) => navigate(`details-bdc/${bdcId}`)}
            />
          ) : <p>Aucun BDC à afficher pour ce client.</p>
        ) : (
          <div>
            <span className="total-mois">Total par mois</span>
            <ClientMonthlyTotals months={summary.months} totalsByMonth={summary.totalsByMonth} />
          </div>
        )}
      </section>
    </div>
  );
};

export default ClientBDC;
